/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { store } from "@/main";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";
export const createSurveyGroupTerm = async (code, termCode) => {
  try {
    const url = generateApiUrl(["survey", "surveyGroupTerm"], [code]);
    const payload = {
      term_code: termCode,
    };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const confirmWomenInfluence = async (parvandehCode) => {
  try {
    const url = generateApiUrl(["survey", "womenInfluenceConfirm"]);
    const payload = { parvandeh_code: parvandehCode };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
